// extracted by mini-css-extract-plugin
module.exports = {"link":"FaqLink_link__XXq4C"};